export default __webpack_public_path__ + "static/media/cp_geo_mx.10f3746d.svg";